import React, {useEffect, useRef} from 'react';
import {useDispatch} from 'react-redux';
import classNames from 'classnames';
import {scrolledToService} from 'shared/portfolio/actions/community-service';
import {CommunityService} from './community-service-form-wrapper';
import Text from 'shared/components/text';
import {MONTH_ABBRVS} from 'shared/utils';

interface Props {
  communityServiceEvent: CommunityService;
  hover?: boolean;
}

const CommunityServiceEvent = ({
  communityServiceEvent: {
    dateRange,
    startMonth,
    startYear,
    endMonth,
    endYear,
    place,
    description,
    hours,
    scrollTo,
    _id,
  },
  hover,
}: Props) => {
  const ref = useRef<HTMLDivElement>(null);
  const dispatch = useDispatch();

  useEffect(() => {
    if (scrollTo) {
      setTimeout(() => {
        ref.current?.scrollIntoView({behavior: 'smooth'});
        dispatch(scrolledToService(_id));
      }, 550);
    }
  }, [_id, dispatch, scrollTo]);

  return (
    <div ref={ref}>
      <div
        className={classNames('portfolio-sections header-container', {
          'larger-left-side': !dateRange,
        })}
      >
        <div className="portfolio-sections card-header">
          <Text header emphasis inline weight={4} hover={hover}>
            {place}
          </Text>
        </div>
        {hover || (
          <Text inline weight={5} hover={hover} className="portfolio-sections year-ranges">
            {MONTH_ABBRVS[startMonth]} {startYear}
            {dateRange && endMonth !== null ? ` - ${MONTH_ABBRVS[endMonth]} ${endYear}` : ''}
          </Text>
        )}
      </div>
      <Text weight={5} hover={hover} color="darkgrey">
        {description}
      </Text>
      <Text weight={5} hover={hover} color="darkgrey">
        {`${hours} ${hours === 1 ? 'hour' : 'hours'}`}
      </Text>
    </div>
  );
};

export default CommunityServiceEvent;
